import {
    forwardRef,
    useImperativeHandle,
    useRef,
} from 'react'

const PdfViewer = forwardRef(({ title, pdfUrl }, ref) => {
    const iframeRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            return {
                isValid: true,
                value: {
                    result: true,
                    pdfUrl,
                    isLastPageShown: true,
                },
            }
        },
    }))

    return (
        <div className="flex flex-col items-center px-4 py-4 space-y-2 w-full h-full">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-800 text-center max-w-2xl">
                {title}
            </h1>

            <iframe
                ref={iframeRef}
                src={pdfUrl}
                title="PDF Viewer"
                className="w-full max-w-4xl  h-full border rounded-xl shadow-md"
            />
        </div>
    )
})

export default PdfViewer
